<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">{{ $t("settings.alcoholSaleRestriction") }}</h2>

    <b-message type="is-warning" size="is-small">
      {{ $t("settings.alcoholSaleRestrictionAllStoresWarning") }}
    </b-message>

    <div class="columns">
      <div class="column">
        <b-field :label="$t('settings.alcoholSaleRestrictionActive')">
          <b-switch
            size="is-small"
            class="switch"
            type="is-primary"
            v-model="active"
            passive-type="is-secondary"
          ></b-switch>

          {{ active ? $t("common.Enabled") : $t("common.Disabled") }}
        </b-field>
      </div>

      <div class="column">
        <b-field :label="$t('settings.alcoholSaleRestrictionStartDate')">
          <b-datetimepicker
            v-model="startDate"
            :placeholder="$t('settings.alcoholSaleRestrictionPickDate')"
            :disabled="!active"
            icon="calendar-alt"
            locale="pt-BR"
          ></b-datetimepicker>
        </b-field>
      </div>

      <div class="column">
        <b-field :label="$t('settings.alcoholSaleRestrictionEndDate')">
          <b-datetimepicker
            v-model="endDate"
            :placeholder="$t('settings.alcoholSaleRestrictionPickDate')"
            :disabled="!active"
            icon="calendar-alt"
            locale="pt-BR"
          ></b-datetimepicker>
        </b-field>
      </div>

      <div class="column is-narrow">
        <b-field label="&nbsp;">
          <button class="button is-primary" @click="save">
            {{ $t("common.save") }}
          </button>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      active: false,
      startDate: null,
      endDate: null
    };
  },

  computed: {
    ...mapGetters(["preferences"])
  },

  watch: {
    preferences: {
      immediate: true,
      handler() {
        this.loadFromPreferences();
      }
    }
  },

  methods: {
    loadFromPreferences() {
      const restriction =
        (this.preferences && this.preferences.alcoholSaleRestriction) || {};
      this.active = !!restriction.active;
      this.startDate = restriction.startDate
        ? new Date(restriction.startDate)
        : null;
      this.endDate = restriction.endDate ? new Date(restriction.endDate) : null;
    },

    save() {
      if (
        this.active &&
        (!this.startDate || !this.endDate || this.endDate <= this.startDate)
      ) {
        this.alertCustomError(
          this.$t("settings.alcoholSaleRestrictionInvalidPeriod")
        );
        return;
      }

      this.isLoading = true;
      this.$store
        .dispatch("setAlcoholSaleRestriction", {
          active: this.active,
          startDate: this.startDate ? this.startDate.toISOString() : null,
          endDate: this.endDate ? this.endDate.toISOString() : null
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: this.$t("settings.alcoholSaleRestrictionSaved"),
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
